module.exports = __webpack_public_path__ + "static/media/grocery_set_important.6d350976.svg";